import { consoleEvents } from '@pb/utils'

import {
  DEFAULT_REDEEM_MINUTES,
  LOCAL_STORAGE_OFFER_ID_KEY,
  LOCAL_STORAGE_OFFER_KEY,
  LOCAL_STORAGE_OFFER_REDEEM_EXPIRE_KEY,
} from '../constants'

const getRedeemExpireTime = (minutes): any => Date.now() + minutes * 60000

const getLsKeys = (customerLoyaltyId): any => {
  const lsRedeemedOfferId = `${customerLoyaltyId}${LOCAL_STORAGE_OFFER_ID_KEY}`
  const lsRedeemedOffer = `${customerLoyaltyId}${LOCAL_STORAGE_OFFER_KEY}`
  const lsRedeemedOfferEndTime = `${customerLoyaltyId}${LOCAL_STORAGE_OFFER_REDEEM_EXPIRE_KEY}`
  return { lsRedeemedOfferId, lsRedeemedOffer, lsRedeemedOfferEndTime }
}

const hasExpiredOfferInLocalStorage = (LS, customerLoyaltyId): any => {
  const { lsRedeemedOfferEndTime } = getLsKeys(customerLoyaltyId)
  const timestamp =
    lsRedeemedOfferEndTime && parseInt(JSON.parse(LS.getItem(lsRedeemedOfferEndTime)), 10)
  // @ts-expect-error ts-migrate(2363) FIXME: The right-hand side of an arithmetic operation mus... Remove this comment to see the full error message
  return (timestamp && timestamp - new Date() <= 0) || false
}

const isInLocalStorage = (LS, customerLoyaltyId, offerPropositionId): any => {
  const { lsRedeemedOfferId } = getLsKeys(customerLoyaltyId)

  try {
    return offerPropositionId && JSON.parse(LS.getItem(lsRedeemedOfferId)) === offerPropositionId
  } catch (e) {
    consoleEvents.error(`Could not fetch localStorage ${lsRedeemedOfferId}: ${e}`)
    return false
  }
}

const getOfferIdFromLocalStorage = (LS, customerLoyaltyId): any => {
  const { lsRedeemedOfferId } = getLsKeys(customerLoyaltyId)

  try {
    return JSON.parse(LS.getItem(lsRedeemedOfferId))
  } catch (e) {
    consoleEvents.error(`Could not fetch localStorage ${lsRedeemedOfferId}: ${e}`)
    return false
  }
}

const getOfferFromLocalStorage = (LS, customerLoyaltyId): any => {
  const { lsRedeemedOffer } = getLsKeys(customerLoyaltyId)
  let offer = {}
  try {
    offer = JSON.parse(LS.getItem(lsRedeemedOffer)) || {}
  } catch (e) {
    consoleEvents.error(`Could not fetch localStorage hmClubOfferPropositionIds: ${e}`)
  }

  return offer || null
}

const removeOfferFromStorage = (LS, customerLoyaltyId): any => {
  const lsKeys = getLsKeys(customerLoyaltyId)
  Object.keys(lsKeys).forEach((key) => {
    LS.removeItem(lsKeys[key])
  })
}

const setActiveOfferToLocalStorage = (LS, customerLoyaltyId, offer): any => {
  const { lsRedeemedOfferId, lsRedeemedOffer, lsRedeemedOfferEndTime } =
    getLsKeys(customerLoyaltyId)
  const activeOfferExpiresAt = getRedeemExpireTime(
    offer?.loyaltyOffersCounter || DEFAULT_REDEEM_MINUTES,
  )

  LS.setItem(lsRedeemedOfferId, offer?.offerPropositionId)
  LS.setItem(
    lsRedeemedOffer,
    JSON.stringify({ ...offer, isOfferActive: true, activeOfferExpiresAt }),
  )
  LS.setItem(lsRedeemedOfferEndTime, activeOfferExpiresAt)
}

const getActiveOfferExpiresAt = (LS, customerLoyaltyId): any => {
  const { lsRedeemedOfferEndTime } = getLsKeys(customerLoyaltyId)

  try {
    return parseInt(JSON.parse(LS.getItem(lsRedeemedOfferEndTime)), 10)
  } catch (e) {
    consoleEvents.error(`Could not fetch localStorage ${lsRedeemedOfferEndTime}: ${e}`)
    return null
  }
}

export {
  hasExpiredOfferInLocalStorage,
  removeOfferFromStorage,
  getActiveOfferExpiresAt,
  setActiveOfferToLocalStorage,
  isInLocalStorage,
  getOfferIdFromLocalStorage,
  getOfferFromLocalStorage,
  getRedeemExpireTime,
}
